//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationLayout",
  props: {
    showSidebar: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    const toggleSidebar = () => {
      emit("toggle-sidebar");
    };
    return {
      toggleSidebar
    };
  }
});